module.exports = {"items":[{"title":"Петиция","slug":"petition"},{"title":"Заявление организаций","slug":"position"},{"title":"Для прессы","slug":"press-kit"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/action-nav.ru.json
// module id = 139
// module chunks = 0